export default "__VITE_ASSET__a473084b__"